import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { UserPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface UserProjectModel {
    projectTypeId: number
    projectId: number
    userId: number
    functionalRoleId: number
}

const AddUserToProjectPopup: React.FC<UserPopupProps> = ({ show, onHide, userId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<UserProjectModel>>({ isSuccesful: true, messages: [], data: undefined });
    const [formData, setFormData] = useState<UserProjectModel>({
        projectTypeId: 0,
        projectId: 0,
        userId: userId,
        functionalRoleId: 0,
    });

    const projectTypes = useSelectListOptions('api/v1/selectlist/ProjectTypes', '-- Select projecttype');
    const projects = useSelectListOptions('api/v1/selectlist/Projects?projectTypeId=' + formData.projectTypeId, '-- Select project');
    const roles = useSelectListOptions('api/v1/selectlist/WorkflowRoles?projectTypeId=' + formData.projectTypeId , '-- Select role');
    const { handleResult, handleException } = useNotifications();


    function submit() {
        if (formData) {
            DataService
                .create<UserProjectModel>(`api/v1/ProjectUsers`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'projectTypeId', label: 'Projecttype', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'projectId', label: 'Project', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'functionalRoleId', label: 'Role', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add to Project'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('projectTypeId')} options={projectTypes} />
                <SelectListField {...getFieldProps('projectId')} options={projects} />
                <SelectListField {...getFieldProps('functionalRoleId')} options={roles} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserToProjectPopup;